




































import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../../domain/editableFormat";
import { FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin } from "../../mixins";
import { default as FormatObjectOrderTool } from "./FormatObjectOrderTool.vue";
import { default as FormatObjectSortTool } from "./FormatObjectSortTool.vue";

@Component({
  components: {
    FormatObjectOrderTool,
    FormatObjectSortTool
  },
})
export default class FormatObjectListTool extends Mixins(ModelEditableMixin, FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin) {
  toRowClassName(row: IFormatObjectEditable): string {
    return row.isSelected() ? "selected" : "";
  }

  toCellElementName(row: IFormatObjectEditable): string {
    return row.getTypeName();
  }

  toCellId(row: IFormatObjectEditable): string {
    const id = row.id().getValue();
    return id ? id.toString() : "";
  }

  toCellName(row: IFormatObjectEditable): string {
    const name = row.getIdentifiableName();
    return name ? name : "";
  }

  async onClicked(object: IFormatObjectEditable, event: PointerEvent): Promise<void> {
    if (event.shiftKey) {
      const objs = this.lastSelectedObject
        ? this.rangeSelectionObjects(object, this.lastSelectedObject)
        : [object];
      this.deselectAllObjects();
      await this.$nextTick();
      this.selectObjects(...objs);
      return;
    }
    const isSelected = object.isSelected();
    if (!event.ctrlKey) {
      this.deselectAllObjects();
      await this.$nextTick();
    }
    if (isSelected) {
      this.deselectObjects(object);
    } else {
      this.selectObjects(object);
    }
  }

  async selectNamePartialMatchedObjects(): Promise<void> {
    await this.getCommonComponents().getDialogs().getNamedObjectsSelectDialog().show();
  }
}
